<template>
    <div>
		<div class="page-title">Контакты</div>
		<div class="contacts">
			<div class="contacts__item" v-for="item in items">
				<a class="contacts__item-main" :href="item.link">
					<div class="contacts__item-banner">
						<img class="contacts__item-banner-img" :src="item.src">
					</div>
					<span class="contacts__item-title">
						{{ item.title }}
						<svg class="contacts__item-title-icon">
							<use href="#svg-icon-checked"></use>
						</svg>
					</span>
					<span class="contacts__item-extra">
						{{ item.linkText }}
					</span>
					<span class="contacts__item-note">
						{{ item.description }}
					</span>
				</a>
				<div class="contacts__item-action">
					<a class="btn btn--block" :href="item.link">
						{{ item.buttonText }}
					</a> 
				</div>
			</div>
		</div>
    </div>
</template>

<script>
export default {
	data() {
		return {
			items: [
				{
					title: 'BOOM-X ТЕХПОДДЕРЖКА',
					description: 'Отвечаем 10:00-23:00 каждый день',
					link: 'https://t.me/boomx_support',
					linkText: 't.me/boomx_support',
					src: '/assets/boomx/images/Logo.svg',
					buttonText: 'Отправить сообщение',
				},
				{
					title: 'BOOM-X MANAGER',
					description: 'Отвечаем 10:00-23:00 каждый день',
					link: 'https://t.me/boomx_manager',
					linkText: 't.me/boomx_manager',
					src: '/assets/boomx/images/Logo.svg',
					buttonText: 'Отправить сообщение',
				},
				{
					title: 'BOOM-X | ВКОНТАКТЕ',
					description: 'Ежедневно выдаём промокоды',
					link: 'https://vk.com/boomx_casino',
					linkText: 'vk.com/boomx_casino',
					src: '/assets/boomx/images/Logo.svg',
					buttonText: 'Перейти в сообщество',
				},
				{
					title: 'BOOM-X | TELEGRAM',
					description: 'Ежедневно выдаём промокоды',
					link: 'https://t.me/boomx_casino',
					linkText: 't.me/boomx_casino',
					src: '/assets/boomx/images/Logo.svg',
					buttonText: 'Перейти в канал',
				},
			]
		}
	}
}
</script>